import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import remarkGfm from "remark-gfm";
import { CalenderIcon, ClockIcon } from "../../../icons";
import formatDateTime from "../../Common/formatDateTime";
import { GET_READ_TIME, GET_TEXT_HTML } from "../../../common/utils";

const CompanyNewsView = props => {
  const { news, onClose } = props;
  const [readTime, setReadTime] = useState("");
  const [content, setContent] = useState("");

  useEffect(() => {
    if (!news?.content) return;
    let summary = GET_TEXT_HTML(news?.content);
    let rTime = GET_READ_TIME(summary);
    setReadTime(rTime);
    let textContnet = news?.content?.split("READ NEXT: ")?.[0];
    textContnet = textContnet?.replace("\n\nStory Continues\n\n", "\n\n");
    textContnet = textContnet?.split("Click here for the latest ")?.[0];
    textContnet = textContnet
      ?.replace("\nView Comments", "")
      ?.replace("\nView comments", "")
      ?.replace("\nStory continues", "");
    setContent(textContnet);
  }, [news]);

  return (
    <Dialog
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-dialog"
      fullWidth={true}
      maxWidth="md"
      PaperProps={{
        sx: {
          width: "100%",
        },
      }}
    >
      <DialogContent>
        <h1 className="event-page-company-news-title">{news?.title}</h1>

        <div className="events-page-post-static">
          {news?.date ? (
            <div className="events-page-post-static-item">
              <div className="events-page-post-static-item-text">
                <CalenderIcon />
                {formatDateTime(news?.date)}
              </div>
            </div>
          ) : null}
          <div className="events-page-post-static-item">
            <div className="events-page-post-static-item-text">
              <ClockIcon /> {readTime}
            </div>
          </div>
        </div>
        <div className="event-page-company-news-text">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              a: ({ node, ...props }) => (
                <a
                  {...props}
                  target="_blank"
                  className="text-link text-primary"
                  rel="noopener noreferrer"
                >
                  {props.children}
                </a>
              ),
            }}
          >
            {content}
          </ReactMarkdown>
        </div>
      </DialogContent>

      <DialogActions className="custom-dialog-action text-center">
        <Button
          variant="outlined"
          color="secondary"
          className="events6ix-btn events6ix-btn-light"
          type="button"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompanyNewsView;
